import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id       : 'applications',
        title    : 'Applications',
        translate: 'NAV.APPLICATIONS',
        type     : 'group',
        icon     : 'apps',
        children : [
            {
                id       : 'dashboard',
                title    : 'Dashboard',
                translate: 'Dashboard',
                type     : 'item',
                icon     : 'home',
                url      : '/dashboard',
                exactMatch: true,
            },
            {
                id       : 'training',
                title    : 'Training',
                translate: 'Training',
                type     : 'item',
                icon     : 'directions_run',
                url      : '/training',
                exactMatch: true,
            },
            {
                id       : 'trainer-dashboard',
                title    : 'Dashboard',
                translate: 'Dashboard',
                type     : 'item',
                icon     : 'calendar_view_day',
                url      : '/trainer-dashboard',
                exactMatch: true,
                hidden:     true,
            },
            {
                id       : 'calendar',
                title    : 'Calendar',
                translate: 'Calendar',
                type     : 'item',
                icon     : 'calendar_today',
                url      : '/calendar',
                exactMatch: true
            },
            {
                id       : 'customers',
                title    : 'Customers',
                translate: 'Customers',
                type     : 'item',
                icon     : 'people',
                url      : '/customers',
                exactMatch: false
            },
            {
                id       : 'warehouse',
                title    : 'Warehouse',
                translate: 'Warehouse',
                type     : 'item',
                icon     : 'kitchen',
                url      : '/products',
                exactMatch: false
            },
            {
                id       : 'reports',
                title    : 'reports',
                translate: 'reports',
                type     : 'item',
                icon     : 'insert_chart',
                url      : '/reports-list',
                exactMatch: false
            },
            {
                id       : 'communication',
                title    : 'Communication',
                translate: 'Communication',
                type     : 'item',
                icon     : 'sms',
                url      : '/communication',
                exactMatch: false
            },
            {
                id       : 'services',
                title    : 'Services',
                translate: 'Services',
                type     : 'item',
                icon     : 'local_offer',
                url      : '/services',
                exactMatch: false
            },
            {
                id        : 'settings',
                title     : 'Settings',
                translate : 'Settings',
                type      : 'item',
                icon      : 'settings',
                url       : '/settings',
                exactMatch: false
            },
            {
                id        : 'notes',
                title     : 'Notes',
                translate : 'Notes',
                type      : 'item',
                icon      : 'description',
                url       : '/notes',
                exactMatch: false
            }
        ]
    }
];
